import emailOptInSubscribeModal from './emailOptInSubscribeModal';

export default emailOptInSubscribeModal;
